import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
import ContentHeader from '../components/ContentHeader';
import ButtonLink from '../components/ButtonLink';

const styles = theme => ({
    root: {
        textAlign: 'center',
        border: '0',
        maxWidth: '800px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 15px'
        }
    },
    heading: {
        marginBottom: '10px'
    },
    subheading: {
        marginTop: '20px'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    },
    inner: {
        padding: '20px 10px'
    },
    button: {
        margin: '5px 5px'
    }
});

const TopUpConfirmed = ({ classes, match }) => {
    const {
        params: { customerTicketId }
    } = match;

    return (
        <div className={classes.root}>
            <ContentHeader
                text="Top-up Confirmed"
                id="topup-confirmed-heading"
            />
            <div className={classes.inner}>
                <Typography className={classes.paragraph} variant="body2">
                    Congratulations, your top-up was successful.
                </Typography>
                <Typography className={classes.paragraph} variant="body2">
                    <ButtonLink
                        className={classes.button}
                        variant="outlined"
                        color="primary"
                        to={`/ticket/${customerTicketId}`}
                    >
                        View ticket
                    </ButtonLink>
                    <ButtonLink
                        className={classes.button}
                        variant="outlined"
                        color="primary"
                        to="/"
                    >
                        My tickets
                    </ButtonLink>
                </Typography>
            </div>
        </div>
    );
};

export default withStyles(styles)(TopUpConfirmed);
